<template>
    <div class="con-list">
		<div class="info">提示：附件需要图片格式或PDF格式，不接受压缩包</div>
		<el-table
			v-loading='vLoading'
			:data="applyData.hrAttachs">
			<el-table-column
				label="序号"
				align="center"
				min-width="40"
				header-align="center">
				<template slot-scope="scope">
					<span>{{scope.$index+1}}</span>
				</template>
			</el-table-column>
			<el-table-column
				label="附件名称"
				align="center"
				min-width="220"
				header-align="center">
				<template slot-scope="scope">
					<el-select
						:disabled='isDetail'
						v-model="scope.row.pageModual">
						<!-- <el-option
							label="背调授权书"
							value="back_check"></el-option> -->
						<el-option
							label="其他"
							value="oth"></el-option>
					</el-select>
				</template>
			</el-table-column>
			<el-table-column
				label="附件"
				align="center"
				min-width="220"
				prop="attachSaveName"
				header-align="center">
				<template slot-scope="scope">
					<span
						class="file-name"
						@click="downloadFile(scope.row)">{{scope.row.attachSaveName}}</span>
				</template>
			</el-table-column>
			<el-table-column
				v-if="!isDetail"
				label="上传"
				align="center"
				min-width="80"
				header-align="center">
				<template slot-scope="scope">
					<el-upload
						:disabled='!!scope.row.attachSaveName'
						:with-credentials='true'
						:data="{saveFlag: 'N'}"
						:show-file-list='false'
						:on-success='handleFileUpload.bind(this, scope.$index)'
						:on-error='handleFileError'
						:before-upload='handleBeforeUpload'
						accept='.jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF'
						:action="attachUrl">
						<div class="u-upload-btn">
							<img
								src="https://image.guazistatic.com/gz01200517/15/46/f370bdfe4dd9bd168e955780340a06da.png"
								class="upload">
						</div>
					</el-upload>
				</template>
			</el-table-column>
			<el-table-column
				v-if="!isDetail"
				label="删除"
				align="center"
				min-width="80"
				header-align="center">
				<template slot-scope="scope">
					<span class="el-icon-delete" @click='delLine(scope.$index, scope.row)'></span>
				</template>
			</el-table-column>
		</el-table>
		<div class="add-new-line" v-if="!isDetail">
			<div class="u-add-tile-btn" @click="addNewLine">+ 新增一行</div>
		</div>
		<!-- <template v-if="!isDetail">
			<div class="con-title">背调授权书模板</div>
			<a
				@click="getBgCheck"
				class="attach-template">下载背调授权书模板</a>
		</template> -->
	</div>
</template>

<script>
import { getBgCheck, attachUrl, downloadByUrl, downloadAttach } from '@/network'

export default {
    name: 'socialInfo',
	props: ['applyData', 'isDetail'],
	data() {
		return {
			vLoading: false,
			attachUrl,
		}
	},
	methods: {
		addNewLine() {
			this.applyData.hrAttachs.push({
				pageModual: 'oth',
				attachModule: 'outside',
				delFlag: '0',
			})
		},
		async getBgCheck() {
			let res = await getBgCheck().catch({})
			if (!res) return
			if (res.data.data) {
				window.location.href = res.data.data
			}
		},
		handleFileUpload(index, res) {
			this.vLoading = false
			let { data } = res
			this.$set(this.applyData.hrAttachs[index], 'attachSaveName', data.fileName)
			this.$set(this.applyData.hrAttachs[index], 'attachSavePath', data.viewUrl)
			this.$set(this.applyData.hrAttachs[index], 'fileUniqueId', data.fileId)
			this.$set(this.applyData.hrAttachs[index], 'downloadUrl', data.downloadUrl)
		},
		handleFileError() {
			this.vLoading = false
			this.$message.error('上传失败')
		},
		handleBeforeUpload() {
			this.vLoading = true
		},
		delLine(index, data) {
			this.applyData.hrAttachs.splice(index, 1)
			// console.log(index, data)
		},
		downloadFile(data) {
			if (data.downloadUrl) {
				window.location.href = data.downloadUrl
			} else {
				this.downloadAttach({
					attachId: data.attId
				})
			}
		},
		async downloadAttach(params) {
			let res = await downloadAttach(params).catch(() => {})
			if (!res) return
			window.location.href = res.data.data
		},
		downloadBlob(url) {
			downloadByUrl(url).then((res) => {
				let { data } = res
				if (data.type === 'application/json') {
					let reader = new FileReader()
					reader.addEventListener('loadend', () => {
						const { message } = JSON.parse(reader.result)
						this.$message.error(message || '下载失败')
					})
					reader.readAsText(data, 'utf-8')
				} else {
					let blob = new Blob([data])
					let elink = document.createElement('a')
					elink.download = data.attachSaveName
					elink.style.display = 'none'
					elink.href = URL.createObjectURL(blob)
					document.body.appendChild(elink)
					elink.click()
					URL.revokeObjectURL(elink.href) // 释放URL 对象
					document.body.removeChild(elink)
				}
			})
		}
	},
}
</script>
<style scoped>
.info{
	color: #FA5050;
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 10px 10px;
}
.u-upload-btn .upload{
	width: 40px;
}
.attach-template{
    color: #11ca78;
	font-size: 14px;
	padding-left: 12px;
	cursor: pointer;
}
.file-name{
	color: #11ca78;
	cursor: pointer;
}
</style>